import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** The column definition for the workspace's groups table with the field property typed */
export type WorkspaceGroupsTableGridColDef = DataGridCellParams<
  FaroCoreApiTypes.AdmCompanyGroup,
  WorkspaceGroupsTableColumnField
>;

/** The column fields that can be used in the workspace's groups table */
export type WorkspaceGroupsTableColumnField =
  | "name"
  | "managerCount"
  | "projectCount"
  | "sqftUsed"
  | "sqftAssigned"
  | "createdDate"
  | "options";

/** The labels for the columns in the workspace's groups table */
export const WORKSPACE_GROUPS_TABLE_COLUMN_LABELS: Record<
  WorkspaceGroupsTableColumnField,
  string
> = {
  name: "Name",
  managerCount: "Number of Members",
  projectCount: "Number of Projects",
  sqftUsed: "Sqft Used",
  sqftAssigned: "Sqft Assigned",
  createdDate: "Created At",
  options: "",
};
